import SettingFrame from "../../../../components/@settings/SettingFrame";
import UpdateLocation from "../../../../components/@locations/locations/UpdateLocation";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function LocationUpdatePage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <UpdateLocation
                routeType={routeType}
            />
        </SettingFrame>
    )
}